import { useMemo } from 'react';
import type { NormalizedInputProps } from '../types/input.types';

interface UseNormalizedInputPropsArgs {
  id: string;
  readOnly?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  invalidText?: React.ReactNode;
  warn?: boolean;
  warnText?: React.ReactNode;
}

/**
 * Hook to normalize input props and generate IDs for helper elements
 */
export function useNormalizedInputProps({
  id,
  readOnly,
  disabled,
  invalid,
  invalidText,
  warn,
  warnText,
}: UseNormalizedInputPropsArgs): NormalizedInputProps {
  const normalizedProps = useMemo(() => {
    const normalized: NormalizedInputProps = {
      disabled: Boolean(disabled),
      invalid: Boolean(invalid && !readOnly && !disabled),
      invalidId: `${id}-error-msg`,
      warn: Boolean(warn && !invalid && !readOnly && !disabled),
      warnId: `${id}-warn-msg`,
      helperId: `${id}-helper-text`,
    };

    // Invalid state takes precedence over warning
    if (normalized.invalid) {
      normalized.warn = false;
    }

    return normalized;
  }, [id, readOnly, disabled, invalid, warn]);

  return normalizedProps;
}
